import React, {PureComponent} from "react"
import {Row, Col} from "react-bootstrap"

import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {RouterLink} from "@irati/ui/src/Link"
import {Body} from "@irati/ui/src/Typography"
import noUsedPerks from "@irati/ui/images/no-used-perks.svg"

import {NoPerksImage} from "../styled/NoPerks"

interface Props extends InjectIntl {
  usedPerksOptionActive?: boolean
}

class NoPerks extends PureComponent<Props> {
  render() {
    const {usedPerksOptionActive, formatMessage} = this.props

    return (
      <Row>
        <Col xs={12}>
          <Flex direction="column" alignItems="center">
            <NoPerksImage src={noUsedPerks} alt={formatMessage({id: "perks.myPerks.noUsedPerks.img.alt"})} />
            {usedPerksOptionActive && (
              <Body small>
                <FormattedMessage id="perks.myPerks.noUsedPerks.para" />
              </Body>
            )}
          </Flex>
          {!usedPerksOptionActive && (
            <Body id="nothingFound" small textAlign="center">
              <FormattedMessage
                id="perks.myPerks.noPerks.emptyState.cta.text"
                values={{
                  link: (
                    <RouterLink cta to="/">
                      <FormattedMessage id="perks.myPerks.noPerks.emptyState.cta.here" />
                    </RouterLink>
                  )
                }}
              />
            </Body>
          )}
        </Col>
      </Row>
    )
  }
}

export default injectIntl(NoPerks)
